export default "__VITE_ASSET__CpN6nY_6__"